import { c as _c } from "react/compiler-runtime";
import { MemberRoleMenuButton } from "@components/table/members/member-role-menu-button";
import { RemoveMemberFromTeamMenuButton } from "@components/table/teams/remove-member-from-team-menu-button";
import { RemoveTeamMenuButton } from "@components/table/teams/remove-team-menu-button";
import { DeleteIcon, SelectionIcon, UserRoleIcon, VisibleIcon } from "@flat-ui";
import { useTeamsAccess } from "@hooks/access-control/use-teams-access";
import { useMediaQueryList } from "@hooks/use-media-query";
import { useTeamUtils } from "@hooks/use-team-utils";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { selectedRowIdsSelector } from "@store/table/table-selector";
import { setInitialFetchingItems } from "@store/table/table-slice";
import { toggleItemSelection } from "@utils/array-utils";
/**
 * Custom hook to get the menu options for a team.
 * Provides actions for selecting, viewing details, changing role, and removing a team.
 */
export function useTeamMenuOptions(t0) {
  const $ = _c(33);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    shouldExcludeRemove: t2,
    memberToRemove
  } = t1;
  const shouldExcludeRemove = t2 === undefined ? false : t2;
  const dispatch = useAppDispatch();
  const companyId = useCompanyId();
  const selectedRowIds = useAppSelector(selectedRowIdsSelector);
  const {
    openTeamDetails
  } = useTeamUtils();
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const {
    canChangeTeamRole,
    canDeleteTeams,
    canDeleteMembersFromTeam
  } = useTeamsAccess();
  let t3;
  if ($[2] !== dispatch || $[3] !== selectedRowIds) {
    t3 = team => {
      const newSelectedRowIds = toggleItemSelection(selectedRowIds, team.id);
      dispatch(setInitialFetchingItems(newSelectedRowIds));
    };
    $[2] = dispatch;
    $[3] = selectedRowIds;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isScreenSmOrSmaller) {
    t4 = () => isScreenSmOrSmaller;
    $[5] = isScreenSmOrSmaller;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isScreenSmOrSmaller || $[8] !== t3 || $[9] !== t4) {
    t5 = {
      label: "Select team",
      Icon: SelectionIcon,
      onSelect: t3,
      shouldShow: t4,
      shouldShowDividerAfter: isScreenSmOrSmaller
    };
    $[7] = isScreenSmOrSmaller;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== openTeamDetails) {
    t6 = {
      label: "View details",
      Icon: VisibleIcon,
      onSelect: team_0 => {
        openTeamDetails({
          teamId: team_0.id,
          numberOfMembers: team_0.memberCount
        });
      },
      shouldShowDividerAfter: true
    };
    $[11] = openTeamDetails;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== companyId) {
    t7 = (team_1, onMenuClose) => <MemberRoleMenuButton member={team_1} companyId={companyId} subjectType="team" onMenuClose={onMenuClose} />;
    $[13] = companyId;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== canChangeTeamRole) {
    t8 = () => canChangeTeamRole;
    $[15] = canChangeTeamRole;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = {
      label: "Change role",
      Icon: UserRoleIcon,
      component: t7,
      shouldShow: t8,
      shouldShowDividerAfter: true
    };
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== canDeleteTeams || $[21] !== shouldExcludeRemove) {
    t10 = {
      label: "Remove team",
      Icon: DeleteIcon,
      component: _temp,
      shouldShow: team_3 => !shouldExcludeRemove && canDeleteTeams && !team_3.category.isManaged
    };
    $[20] = canDeleteTeams;
    $[21] = shouldExcludeRemove;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== canDeleteMembersFromTeam || $[24] !== companyId || $[25] !== memberToRemove) {
    t11 = memberToRemove ? [{
      label: "Remove from team",
      Icon: DeleteIcon,
      component: (team_4, onMenuClose_1) => <RemoveMemberFromTeamMenuButton companyId={companyId} team={team_4} member={memberToRemove} onMenuClose={onMenuClose_1} />,
      shouldShow: team_5 => canDeleteMembersFromTeam && !team_5.category.isManaged
    }] : [];
    $[23] = canDeleteMembersFromTeam;
    $[24] = companyId;
    $[25] = memberToRemove;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t5 || $[30] !== t6 || $[31] !== t9) {
    t12 = [t5, t6, t9, t10, ...t11];
    $[27] = t10;
    $[28] = t11;
    $[29] = t5;
    $[30] = t6;
    $[31] = t9;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
}
function _temp(team_2, onMenuClose_0) {
  return <RemoveTeamMenuButton team={team_2} onMenuClose={onMenuClose_0} />;
}